import { render, staticRenderFns } from "./ActPedidosGrid.vue?vue&type=template&id=1e4443b1&scoped=true&"
import script from "./ActPedidosGrid.vue?vue&type=script&lang=js&"
export * from "./ActPedidosGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4443b1",
  null
  
)

export default component.exports